import { createFileRoute } from '@tanstack/react-router'
import { CompareIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/comparer/')({
  loader: () => loadPageData({ data: { kind: 'compare', locale: 'fr' } }),
  head: () => staticRouteHead('compare', 'fr'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CompareIndexPage />
    </CatalogProvider>
  )
}
